var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-switch",staticStyle:{"display":"flex","align-items":"center","justify-content":"center"}},[_c('span',{staticClass:"toggle-wrapper",class:{
            'base-switch--on': _vm.booleanValue,
            'base-switch--off': !_vm.booleanValue,
        },style:({
            'width' : _vm.defaultWidth + 'px',
            'height': _vm.defaultHeight + 'px'
        }),attrs:{"id":_vm.elemId},on:{"click":_vm.toggle}},[_c('span',{staticClass:"toggle-background",class:_vm.backgroundStyle}),_vm._v(" "),_c('span',{staticClass:"toggle-indicator",class:_vm.indicatorClass,style:(_vm.indicatorStyle)})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b266e412","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/shared/BaseSwitch.vue
// module id = null
// module chunks = 